/**
 * Guard against browser translators (Google Translate, Chrome's built-in
 * translate) crashing React with
 * "NotFoundError: Failed to execute 'removeChild' on 'Node'".
 *
 * Translators replace our text nodes with their own <font> elements, so when
 * React later removes/inserts next to its original node, that node is no
 * longer a child of the parent it expects and the DOM call throws, taking the
 * whole route down. See https://github.com/facebook/react/issues/11538.
 *
 * Both patches only change behaviour in the exact case that would otherwise
 * throw; every valid call goes straight to the native method.
 */
if (typeof Node === "function" && Node.prototype) {
  const originalRemoveChild = Node.prototype.removeChild;
  Node.prototype.removeChild = function <T extends Node>(
    this: Node,
    child: T
  ): T {
    if (child.parentNode !== this) return child;
    return originalRemoveChild.call(this, child) as T;
  };

  const originalInsertBefore = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function <T extends Node>(
    this: Node,
    newNode: T,
    referenceNode: Node | null
  ): T {
    if (referenceNode && referenceNode.parentNode !== this) return newNode;
    return originalInsertBefore.call(this, newNode, referenceNode) as T;
  };
}

export {};
